import React from 'react'
import { Link } from 'react-router-dom'
import { useSettings } from '../context/SettingsContext'
import Social from './Social';

const Footer = () => {

    const { settings } = useSettings();

    return (
        <>
            <footer>
                <div className="container-fluid web-padding">
                    <div className="row footer-top-row">
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>Dummy Here Lorem</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    <p>Lorem ipsum dolor sit amet.</p>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>Dummy Here Lorem</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    <p>Lorem ipsum dolor sit amet.</p>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>Dummy Here Lorem</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    <p>Lorem ipsum dolor sit amet.</p>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="">
                                <div className="footer-top-card">
                                    <div>
                                        <h5>Dummy Here Lorem</h5>
                                        <span><i className="fa-solid fa-chevron-right" /></span>
                                    </div>
                                    <p>Lorem ipsum dolor sit amet.</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="row footer-lins-row">
                        <div className="col-md-4">
                            <div className="footer-logo">
                                <Link to="/">
                                    {
                                        settings?.logo === null ? <img src="images/footer-logo.png" alt="img" /> : <img src={`${settings?.logo}`} alt="img" />
                                    }

                                </Link>
                                <p>MV Tyres is a family-run business with over 20 years of tyre industry experience. We provide tyres for all vehicles, backed by a mobile fitting service covering all of Scotland. Trusted for professionalism, integrity, and value.</p>
                                <h5>Follow Us</h5>
                                <Social />
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="footer-links-wrapper">
                                        <h5>Useful links</h5>
                                        <ul className="footer-links">
                                            <li><Link to="/">Home</Link> </li>
                                            <li><Link to="/about">About us</Link> </li>
                                            <li><Link to="/services">services</Link> </li>
                                            <li><Link to="/product">products</Link> </li>
                                            <li><Link to="/contact">Contact Us</Link> </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="footer-links-wrapper">
                                        <h5>Recent jobs</h5>
                                        <ul className="footer-links">
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                            <li><Link to="">About Lorem, ipsum.</Link> </li>
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                            <li><Link to="">Lorem, ipsum.</Link> </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="footer-links-wrapper">
                                        <h5>Quick Links</h5>
                                        <ul className="footer-links">
                                            <li><Link to="/policies">Policies</Link></li>
                                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                            <li><Link to="/terms-and-condition">Terms &amp; Condition</Link></li>
                                            <li><Link to="">Help</Link></li>
                                            <li><Link to="">Delivery &amp; Return</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="footer-links-wrapper">
                                        <h5>Products</h5>
                                        <ul className="footer-links">
                                            <li><Link to="/product">Lorem, ipsum. </Link></li>
                                            <li><Link to="/product">Lorem, ipsum. </Link></li>
                                            <li><Link to="/product">Lorem, ipsum. </Link></li>
                                            <li><Link to="/product">Lorem, ipsum. </Link></li>
                                            <li><Link to="/product">Lorem, ipsum. </Link></li>
                                            <li><Link to="/product">Lorem, ipsum. </Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="copy-righjt-para">
                            <p>MV tyres ltd © 2025. All Rights Reserved</p>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer